'use client';

import { SessionProvider as NextAuthSessionProvider, SessionProviderProps } from 'next-auth/react';

interface Props {
  children: React.ReactNode;
  session: SessionProviderProps['session'];
}

export default function SessionProviderWrapper({ children, session }: Props) {
  return (
    <NextAuthSessionProvider
      session={session}
      refetchOnWindowFocus={false}
      refetchInterval={process.env.NODE_ENV === 'development' ? 600 : 0}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
